/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import Component from '@ember/component';

export default class PersonForm extends Component {
  @action
  setSelectedTab(value) {
    this.selectedTab = value;
  }

  @tracked
  selectedTab = 0;
  @tracked preview = false;
  prefix = '';

  @computed('preview', 'fieldGroups.[]', 'person.type')
  get groups() {
    if (this.preview) {
      return this.fieldGroups;
    } else {
      let personType = this.get('person.type');
      return this.fieldGroups.filter(
        (group) => group.personType === personType,
      );
    }
  }

  @action
  savePerson() {
    // Don't try saving if it's a preview, as the record will be an unsaved dummy one.
    if (!this.preview) {
      this.person.save();
    }
  }
}
